export const CONTACT = {
    email: 'info@premassociates.xyz',
    address: '3rd floor Ajmer Rd, Madrampur, Civil Lines, Jaipur, Rajasthan 302006',
    domain: 'premassociates.xyz',
};

export const preselectProduct = (value) =>
    window.dispatchEvent(new CustomEvent('preselect-product', { detail: value }));

export const BANKS = [
    {
        name: 'HDFC Bank',
        code: 'HDFC',
        logo: 'https://upload.wikimedia.org/wikipedia/commons/2/28/HDFC_Bank_Logo.svg',
        type: 'Private Bank',
        accent: '#3B82F6',
        badge: 'Premier Institutional Partner',
        perks: 'Instant disbursal & pre-approved offers',
        products: ['Personal Loan', 'Home Loan', 'Car Loan', 'Business Loan', 'Home Loan Top Up'],
        status: 'Active',
        cta: 'Check Eligibility',
    },
    {
        name: 'ICICI Bank',
        code: 'ICICI',
        logo: 'https://upload.wikimedia.org/wikipedia/commons/1/12/ICICI_Bank_Logo.svg',
        type: 'Private Bank',
        accent: '#F37023',
        badge: 'Strategic Loan Partner',
        perks: 'Competitive home & business rates',
        products: ['Personal Loan', 'Home Loan', 'Business Loan', 'Working Capital Loan', 'Loan Transfer / Balance Transfer'],
        status: 'Active',
        cta: 'Check Eligibility',
    },
    {
        name: 'Axis Bank',
        code: 'AXIS',
        logo: 'https://upload.wikimedia.org/wikipedia/commons/1/1a/Axis_Bank_logo.svg',
        type: 'Private Bank',
        accent: '#AE2A5C',
        badge: 'Priority Banking Partner',
        perks: 'Fast mortgage & car loan processing',
        products: ['Personal Loan', 'Home Loan', 'Car Loan', 'Mortgage Loan', 'Commercial Property Loan'],
        status: 'Active',
        cta: 'Check Eligibility',
    },
    {
        name: 'IndusInd Bank',
        code: 'INDUSIND',
        logo: 'https://upload.wikimedia.org/wikipedia/commons/4/40/IndusInd_Bank_SVG_Logo.svg',
        type: 'Private Bank',
        accent: '#B7273F',
        badge: 'Consumer Finance Partner',
        perks: 'Strong personal & vehicle loan desk',
        products: ['Personal Loan', 'Business Loan', 'Car Loan', 'Working Capital Loan'],
        status: 'Active',
        cta: 'Check Eligibility',
    },
    {
        name: 'HDB Financial Services',
        code: 'HDB',
        logo: 'https://upload.wikimedia.org/wikipedia/commons/5/57/HDB_Financial_Services_logo.svg',
        type: 'NBFC',
        accent: '#ED1C24',
        badge: 'NBFC Lending Partner',
        perks: 'Flexible LAP & express approval',
        products: ['Personal Loan', 'Business Loan', 'Loan Against Property', 'Working Capital Loan'],
        status: 'Active',
        cta: 'Check Eligibility',
    },
    {
        name: 'Poonawalla Fincorp',
        code: 'PF',
        logo: 'https://poonawallafincorp.com/o/pfl-theme/images/favicon.png',
        type: 'NBFC',
        accent: '#FFC20E',
        badge: 'Digital Capital Partner',
        perks: 'Zero-collateral business loans',
        products: ['Business Loan', 'Personal Loan', 'Loan Against Property', 'Loan Transfer / Balance Transfer'],
        status: 'Active',
        cta: 'Check Eligibility',
    },
    {
        name: 'Ujjivan Small Finance Bank',
        code: 'UJJIVAN',
        logo: 'https://upload.wikimedia.org/wikipedia/commons/2/2e/Ujjivan_Small_Finance_Bank.png',
        type: 'Small Finance Bank',
        accent: '#E87722',
        badge: 'Inclusive Banking Partner',
        perks: 'Micro & secured lending expertise',
        products: ['Personal Loan', 'Business Loan', 'Home Loan', 'Working Capital Loan'],
        status: 'Active',
        cta: 'Check Eligibility',
    },
    {
        name: 'Punjab & Sind Bank',
        code: 'PSB',
        logo: 'https://upload.wikimedia.org/wikipedia/commons/e/ef/PSB_logo_23_Nov.svg',
        type: 'Public Sector Bank',
        accent: '#0056A8',
        badge: 'Public Sector Banking Partner',
        perks: 'Attractive mortgage & home rates',
        products: ['Home Loan', 'Mortgage Loan', 'Business Loan', 'Commercial Property Loan'],
        status: 'Active',
        cta: 'Check Eligibility',
    },
    {
        name: 'Punjab National Bank',
        code: 'PNB',
        logo: 'https://upload.wikimedia.org/wikipedia/commons/b/b2/Punjab_National_Bank_new_logo.svg',
        type: 'Public Sector Bank',
        accent: '#D43D6E',
        badge: 'Public Sector Banking Partner',
        perks: 'Attractive top-up & balance-transfer rates',
        products: ['Home Loan', 'Home Loan Top Up', 'Loan Against Property', 'Loan Transfer / Balance Transfer'],
        status: 'Active',
        cta: 'Check Eligibility',
    },
];

export const LOANS = [
    {
        id: 'personal-loan',
        title: 'Personal Loan',
        value: 'Personal Loan',
        category: 'Unsecured',
        eligibleProviders: ['HDFC', 'ICICI', 'AXIS', 'INDUSIND', 'HDB', 'UJJIVAN'],
        status: 'Active',
        tagline: 'Unsecured capital for instant personal, medical, or emergency needs.',
        rate: '10.25%',
        maxAmount: '₹50 Lakhs',
        tenure: 'Up to 60 months',
        features: ['Zero collateral', '24–48 hr credit', 'Minimal paperwork'],
        icon: 'UserCheck',
    },
    {
        id: 'home-loan',
        title: 'Home Loan',
        value: 'Home Loan',
        category: 'Secured',
        eligibleProviders: ['HDFC', 'ICICI', 'AXIS', 'UJJIVAN', 'PSB', 'PNB'],
        status: 'Active',
        tagline: 'Turn your dream property into reality with high eligibility ratios.',
        rate: '8.40%',
        maxAmount: '₹5 Crores',
        tenure: 'Up to 30 years',
        features: ['Flexible EMIs', 'Balance transfer', 'PMAY assistance'],
        icon: 'Home',
    },
    {
        id: 'business-loan',
        title: 'Business Loan',
        value: 'Business Loan',
        category: 'Unsecured',
        eligibleProviders: ['HDFC', 'ICICI', 'INDUSIND', 'HDB', 'PF', 'UJJIVAN', 'PSB'],
        status: 'Active',
        tagline: 'Inject working capital or expand operations with fast-track SME funding.',
        rate: '11.50%',
        maxAmount: '₹1 Crore',
        tenure: 'Up to 84 months',
        features: ['No hypothecation', 'GST-based evaluation', 'Custom repayment'],
        icon: 'Briefcase',
    },
    {
        id: 'car-loan',
        title: 'Car & Auto Loan',
        value: 'Car Loan',
        category: 'Secured',
        eligibleProviders: ['HDFC', 'ICICI', 'AXIS', 'INDUSIND'],
        status: 'Active',
        tagline: 'Drive home your dream vehicle with up to 100% on-road financing.',
        rate: '8.75%',
        maxAmount: '₹1 Crore',
        tenure: 'Up to 7 years',
        features: ['On-road funding', 'Pre-owned cars', 'Low processing fee'],
        icon: 'Car',
    },
    {
        id: 'mortgage-loan',
        title: 'Mortgage Loan',
        value: 'Mortgage Loan',
        category: 'Secured',
        eligibleProviders: ['AXIS', 'PSB', 'PNB', 'HDFC'],
        status: 'Active',
        tagline: 'High-value funding against residential or commercial mortgage.',
        rate: '9.10%',
        maxAmount: '₹10 Crores',
        tenure: 'Up to 20 years',
        features: ['Residential & commercial', 'High loan-to-value', 'Long tenures'],
        icon: 'Landmark',
    },
    {
        id: 'commercial-property-loan',
        title: 'Commercial Property Loan',
        value: 'Commercial Property Loan',
        category: 'Secured',
        eligibleProviders: ['HDFC', 'AXIS', 'PSB', 'HDB'],
        status: 'Active',
        tagline: 'Fund offices, shops and showrooms with lease-rental discounting.',
        rate: '9.75%',
        maxAmount: '₹10 Crores',
        tenure: 'Up to 15 years',
        features: ['Office & retail funding', 'Lease-rental discounting', 'High LTV ratios'],
        icon: 'Store',
    },
    {
        id: 'home-loan-top-up',
        title: 'Home Loan Top Up',
        value: 'Home Loan Top Up',
        category: 'Secured',
        eligibleProviders: ['HDFC', 'ICICI', 'PNB', 'PSB'],
        status: 'Active',
        tagline: 'Extra funds on your existing home loan at near-home-loan rates.',
        rate: '8.90%',
        maxAmount: '₹75 Lakhs',
        tenure: 'Up to 20 years',
        features: ['On existing home loan', 'Minimal documentation', 'Quick sanction'],
        icon: 'TrendingUp',
    },
    {
        id: 'working-capital-loan',
        title: 'Working Capital Loan',
        value: 'Working Capital Loan',
        category: 'Unsecured',
        eligibleProviders: ['ICICI', 'INDUSIND', 'HDB', 'PF', 'UJJIVAN'],
        status: 'Active',
        tagline: 'Keep operations liquid with cash-flow based credit limits.',
        rate: '12.00%',
        maxAmount: '₹75 Lakhs',
        tenure: 'Up to 60 months',
        features: ['Cash-flow based limits', 'Overdraft option', 'GST-based evaluation'],
        icon: 'Wallet',
    },
    {
        id: 'lap-loan',
        title: 'Loan Against Property',
        value: 'Loan Against Property',
        category: 'Secured',
        eligibleProviders: ['HDFC', 'HDB', 'PF', 'PSB', 'PNB'],
        status: 'Active',
        tagline: 'Unlock maximum equity from residential, commercial, or industrial assets.',
        rate: '9.25%',
        maxAmount: '₹10 Crores',
        tenure: 'Up to 15 years',
        features: ['High loan-to-value', 'Retain ownership', 'Tax benefits'],
        icon: 'Building2',
    },
    {
        id: 'balance-transfer',
        title: 'Loan Transfer / Balance Transfer',
        value: 'Loan Transfer / Balance Transfer',
        category: 'Transfer',
        eligibleProviders: ['PF', 'PNB', 'ICICI', 'HDFC'],
        status: 'Active',
        tagline: 'Move your existing loan to a lower rate and slash your EMI.',
        rate: '8.35%',
        maxAmount: 'Existing outstanding',
        tenure: 'Remaining tenure',
        features: ['Lower EMI instantly', 'Top-up available', 'Foreclosure support'],
        icon: 'ArrowLeftRight',
    },
];

export const INSURANCE = [
    {
        id: 'health-insurance',
        title: 'Health Insurance',
        value: 'Health Insurance',
        category: 'Insurance',
        provider: 'Partner network',
        status: 'Active',
        tagline: 'Cashless cover for you and your family across 10,000+ hospitals.',
        cover: '₹5L – ₹1 Cr',
        features: ['Cashless hospitalisation', 'Family floater options', 'Tax benefit u/s 80D'],
        icon: 'HeartPulse',
    },
    {
        id: 'car-insurance',
        title: 'Car Insurance',
        value: 'Car Insurance',
        category: 'Insurance',
        provider: 'Partner network',
        status: 'Active',
        tagline: 'Comprehensive own-damage and third-party cover, issued instantly.',
        cover: 'IDV-based',
        features: ['Own damage + third party', 'Zero-dep add-ons', 'Instant policy issuance'],
        icon: 'CarFront',
    },
    {
        id: 'life-insurance',
        title: 'Life Insurance',
        value: 'Life Insurance',
        category: 'Insurance',
        provider: 'Partner network',
        status: 'Active',
        tagline: 'Term plans that secure your family’s future at honest premiums.',
        cover: 'Up to ₹2 Cr',
        features: ['Term plans', 'Riders available', 'Tax benefit u/s 80C'],
        icon: 'Umbrella',
    },
];

export const PROCESS = [
    {
        step: '01',
        title: 'Share your requirement',
        body: 'One form. Two minutes. Tell us the amount and the purpose — that is all we need to begin.',
    },
    {
        step: '02',
        title: 'We match the right bank',
        body: 'Your profile is compared live across HDFC, ICICI, HDB, Poonawalla Fincorp and PNB to find the sharpest rate you qualify for.',
    },
    {
        step: '03',
        title: 'Sanction & paperwork',
        body: 'We chase the bank, arrange documents at your doorstep and negotiate on your behalf. You simply sign.',
    },
    {
        step: '04',
        title: 'Money in your account',
        body: 'Disbursal straight to your bank account — most personal loans land within 48 hours of sanction.',
    },
];

export const MARQUEE_ITEMS = [
    'Personal Loan',
    'Home Loan',
    'Business Loan',
    'Car Loan',
    'Mortgage Loan',
    'Commercial Property Loan',
    'Home Loan Top Up',
    'Working Capital Loan',
    'Loan Against Property',
    'Balance Transfer',
    'Health Insurance',
    'Car Insurance',
    'Life Insurance',
];

export const formatINR = (n) =>
    '₹' + Math.round(n).toLocaleString('en-IN', { maximumFractionDigits: 0 });

export const formatCompactINR = (n) => {
    if (n >= 1e7) return `₹${(n / 1e7).toFixed(2)} Cr`;
    if (n >= 1e5) return `₹${(n / 1e5).toFixed(2)} L`;
    return formatINR(n);
};
